import { ElementRef } from "@angular/core";
import { BehaviorSubject } from "rxjs";

type ScrollSubject = { allDataLoaded: boolean, nextPageToken: string | null, loadFromScroll?: boolean };
type ScrollOptions = { pageSize: number, eventHeight: number };

export class InfinityScroll {
    pageSize: number;
    scrollEventHeight: number;
    nextPageToken: string | null = null;
    allDataLoaded: boolean = false;
    loading!: boolean;
    loadFromScroll: boolean = false;

    scrollSubject: BehaviorSubject<ScrollSubject>;

    constructor(options?: Partial<ScrollOptions>) {
        this.pageSize = options?.pageSize ?? 10;
        this.scrollEventHeight = options?.eventHeight ?? 50;

        this.scrollSubject = new BehaviorSubject<ScrollSubject>({ allDataLoaded: false, nextPageToken: null });
    }

    resetScroll(scrollContainer: ElementRef<HTMLDivElement>, loading: boolean = false) {
        this.nextPageToken = null;
        this.allDataLoaded = false;
        this.loadFromScroll = false;
        this.loading = loading;
        scrollContainer.nativeElement.scrollTop = 0;
    }

    onDataLoaded(allDataLoaded: boolean, nextPageToken: string | null) {
        this.allDataLoaded = allDataLoaded;
        this.nextPageToken = nextPageToken;
        this.loading = false;
    }

    onScroll(event: any) {    
        const scrollTop = event.target.scrollTop;
        const scrollHeight = event.target.scrollHeight;
        const offsetHeight = event.target.offsetHeight;

        if (scrollHeight - (scrollTop + offsetHeight) < this.scrollEventHeight) {
            this.loadFromScroll = true;
            this.loading = true;

            this.scrollSubject.next({
                allDataLoaded: this.allDataLoaded,
                nextPageToken: this.nextPageToken,
                loadFromScroll: this.loadFromScroll
            });
        }
    }    

}
